var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "info_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".info_svg__st1{fill:none;stroke:#000;stroke-width:1.5;stroke-miterlimit:10}")), /*#__PURE__*/React.createElement("circle", {
    cx: 23.8,
    cy: 25.8,
    r: 10.8,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "info_svg__st1",
    d: "M23.8 24.4v7.7M23.8 20v2.3"
  })));
};
export default SvgInfo;